/**
 * Component: Blog Filters
 * -----------------------------------------------------------------------------
 * Logic related to Blog Filters.
 * @namespace BlogFilters
 */

/**
 * DOM selectors.
 */
const selectors = {
  filters: '[js-blog-filter]',
}

/**
 * Create a new Blog Filters object.
 */
export default () => {

  /**
   * Node Elements.
   */
  const nodes = {
    filters: document.querySelectorAll(selectors.filters),
  }

  /**
   * Initialize component.
   */
  function init() {
    setColors()
  }

  /**
   * Set colors for filter.
   */
  function setColors() {
    nodes.filters.forEach((filter) => {
      const title = filter.getAttribute('js-blog-filter')

      const meta = window.filterColors.find((data) => {
        if (data.title !== title) {
          return false
        }

        return data
      })

      if (!meta) {
        return
      }

      filter.style.setProperty('--filter-color', meta.color)
    })
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
